import React from "react";

export const useOutsideContainersClick = (
  onOutsideClick: () => void,
  ...containerRefs: Array<React.RefObject<Node>>
) => {
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const isOutsideAllContainers = containerRefs.every(containerRef => {
        return !containerRef.current?.contains(event.target as Node);
      });

      if (isOutsideAllContainers) {
        onOutsideClick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onOutsideClick, ...containerRefs]);
};
